import React from "react";
import { Navigate } from "react-router-dom";
export default function DeployLandingPage() {
  return <Navigate to="/limelite" replace />;
}
